import React from "react";
import { Button, MDBInput } from "mdbreact";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTicketAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ApiService from "../../../services/ApiService";
import { toast } from "react-toastify";

class AddGuestTicket extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      ticketId: props.guest && props.guest.ticketId ? props.guest.ticketId : "",
      isLoading: false,
    };
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      ticketId: this.props.guest && this.props.guest.ticketId ? this.props.guest.ticketId : "",
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  submitTicket = async () => {
    const { ticketId } = this.state;
    const { guest, event } = this.props;

    if (!ticketId.trim()) {
      toast.error("Veuillez saisir un ID de ticket");
      return;
    }

    this.setState({ isLoading: true });

    try {
      await ApiService.awaitRequest(
        {
          ticket_id: ticketId,
          guest_id: guest.id,
          event_id: event.id,
        },
        "guests/tickets/assign",
        "post"
      );

      toast.success("Ticket associé avec succès");
      this.toggle();
      this.props.guest.ticketId = ticketId;
      if (this.props.loadData) {
        this.props.loadData(true);
      }
    } catch (error) {
      toast.error("Erreur lors de l'association du ticket");
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { modal, ticketId, isLoading } = this.state;
    const { guest } = this.props;
    
    const hasExistingTicket = guest && guest.ticket_id;
    const ticketIcon = <FontAwesomeIcon
      icon={faTicketAlt}
      title={hasExistingTicket ? "Modifier le ticket" : "Associer un ticket"}
      onClick={this.toggle}
      style={{ cursor: "pointer", color: hasExistingTicket ? "#d81b60" : "inherit" }}
    />;

    return (
      <span>
        {ticketIcon}

        <Dialog
          open={modal}
          onClose={this.toggle}
          aria-labelledby="ticket-dialog-title"
          aria-describedby="ticket-dialog-description"
          PaperProps={{ sx: { minWidth: "500px" } }}
        >
          <DialogTitle
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <span>{hasExistingTicket ? "Modifier le ticket de l'invité" : "Associer un ticket à l'invité"}</span>
            <FontAwesomeIcon
              onClick={this.toggle}
              icon={faTimes}
              style={{ cursor: "pointer" }}
            />
          </DialogTitle>
          <DialogContent>
            <div className="mt-3 mb-4">
              <MDBInput
                label="ID du ticket"
                name="ticketId"
                value={ticketId}
                onChange={this.handleChange}
                type="text"
                outline
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              className="btn grey darken-1 white-text"
              onClick={this.toggle}
              disabled={isLoading}
            >
              Annuler
            </Button>
            <Button
              className="btn pink darken-1 white-text"
              onClick={this.submitTicket}
              disabled={isLoading}
            >
              {isLoading ? "Chargement..." : "Valider"}
            </Button>
          </DialogActions>
        </Dialog>
      </span>
    );
  }
}

export default AddGuestTicket;
